import { render } from "./OrderTypeComponent.vue?vue&type=template&id=3d10a656"
import script from "./OrderTypeComponent.vue?vue&type=script&lang=js"
export * from "./OrderTypeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__